export default __webpack_public_path__ + "static/media/structure.1a4c6207.svg";